import { WebsiteSignIns } from "@/components/connectors/WebsiteSignIns.tsx";
import {
  MainContentWrapper,
  SiteHeaderContent,
  SiteHeaderTitle,
  ViewWrapper,
} from "@/components/layout/ViewWrapper.tsx";

/** Standalone sign-in management page reached from the connectors gallery. */
export const WebsiteSignInsPage = () => (
  <ViewWrapper
    headerContent={
      <SiteHeaderContent includeBackButton hideNav>
        <SiteHeaderTitle>Website sign-ins</SiteHeaderTitle>
      </SiteHeaderContent>
    }
  >
    <MainContentWrapper columns={14} className="flex-1 min-w-0">
      <div className="mx-auto w-full max-w-3xl">
        <WebsiteSignIns />
      </div>
    </MainContentWrapper>
  </ViewWrapper>
);
